"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBABContainer = exports.GKBABContainerContext = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../../common");
require("./GKBABContainer.css");
// Context for the bottom action bar container
exports.GKBABContainerContext = React.createContext({});
/**
 * A wrapper for GKBottomActionBar (deprecated) or GKActionBar when the
 * bar is nested somewhere down the hierarchy.
 *
 * @deprecated in favor of GKActionBar, which can be used
 * with any GKLayoutContainer (including GKLayoutShell).
 */
var GKBABContainer = function (props) {
    // State and Ref
    var _a = React.useState(), element = _a[0], setElement = _a[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var callbackRef = React.useCallback(setElement, []);
    // Set default props.
    var _b = (0, common_1.mapDefaultProps)(props, {
        _gkComponentName: "gk-b-a-b-container",
    }), children = _b.children, otherProps = __rest(_b, ["children"]);
    // Render
    return (React.createElement(exports.GKBABContainerContext.Provider, { value: {
            container: element,
        } },
        React.createElement("div", __assign({}, otherProps, { ref: callbackRef }),
            React.createElement("div", { "data-qa": otherProps["data-qa"] + "--scrollable-content", className: "gk-b-a-b-container-scrollable-content" }, children))));
};
exports.GKBABContainer = GKBABContainer;
